module.exports = __webpack_public_path__ + "static/media/p3.61396865.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/p3.jpeg
// module id = 588
// module chunks = 0